import {MethodDataHandler} from './MethodDataHandler';
import {
    GooglePayAllowedPaymentMethod,
    GooglePayAllowedPaymentMethodParams,
    GooglePayAuthMethods,
    GooglePayCardNetworks,
    GooglePayEnvironment,
    GooglePayPaymentMethodData,
    GooglePayTokenization,
    GooglePayTokenizationType
} from './types/GooglePayPaymentMethodData';
import {PaymentMethodSpecificData} from "./types/PaymentMethodSpecificData";


const GOOGLE_PAY_CARD_PAYMENT_METHOD_TYPE = 'CARD';
export const GOOGLE_PAY_METHOD_ID = 'https://google.com/pay';
const SHIFT_4_GATEWAY_ID = 'shift4payments';

export class GooglePayHandler implements MethodDataHandler {
    constructor(
        private readonly _publicKey: string
    ) {
    }

  enhanceMethod(method: PaymentMethodData, paymentDetails: PaymentDetailsInit): void {
        if (!this.methodMatches(method)) {
            return
        }
        if (method.data === undefined) {
            method.data = {}
        }
        if (method.data.environment === undefined) {
            method.data.environment = this._publicKey.indexOf('_test_') > -1 ? GooglePayEnvironment.TEST : GooglePayEnvironment.PRODUCTION
        }
        if (method.data.apiVersion === undefined) {
            method.data.apiVersion = 2
        }
        if (method.data.apiVersionMinor === undefined) {
            method.data.apiVersionMinor = 0
        }
        if (method.data.allowedPaymentMethods === undefined) {
            method.data.allowedPaymentMethods = [{}]
        }
        method.data.allowedPaymentMethods.forEach(this._enhanceAllowedPaymentMethodItem)
    }


    private readonly _enhanceAllowedPaymentMethodItem = (allowedPaymentMethod: GooglePayAllowedPaymentMethod) => {
        if (allowedPaymentMethod.type && allowedPaymentMethod.type != GOOGLE_PAY_CARD_PAYMENT_METHOD_TYPE) {
            return;
        }
        if (allowedPaymentMethod.type === undefined) {
            allowedPaymentMethod.type = GOOGLE_PAY_CARD_PAYMENT_METHOD_TYPE
        }
        if (allowedPaymentMethod.tokenizationSpecification === undefined) {
            allowedPaymentMethod.tokenizationSpecification = GooglePayHandler.defaultTokenization(this._publicKey)
        }
        if (allowedPaymentMethod.parameters === undefined) {
            allowedPaymentMethod.parameters = {}
        }
        this._enhanceAllowedPaymentMethodParameters(allowedPaymentMethod.parameters)
    };

    private readonly _enhanceAllowedPaymentMethodParameters = (parameters: GooglePayAllowedPaymentMethodParams) => {
        if (parameters.allowedAuthMethods === undefined) {
            parameters.allowedAuthMethods = GooglePayHandler.defaultAllowedAuthMethods()
        }
        if (parameters.allowedCardNetworks === undefined) {
            parameters.allowedCardNetworks = GooglePayHandler.defaultAllowedCardNetworks()
        }
    };

    enhancePaymentRequest() {
    }

    methodMatches(method: PaymentMethodData): method is PaymentMethodSpecificData<GooglePayPaymentMethodData> {
        return method.supportedMethods === GOOGLE_PAY_METHOD_ID;
    }

    static defaultTokenization(publicKey: string): GooglePayTokenization {
        return {
            type: GooglePayTokenizationType.PAYMENT_GATEWAY,
            parameters: {
                gateway: SHIFT_4_GATEWAY_ID,
                gatewayMerchantId: publicKey,
            }
        };
    }

    static defaultAllowedMethodParameters(): GooglePayAllowedPaymentMethodParams {
        return {
            allowedAuthMethods: this.defaultAllowedAuthMethods(),
            allowedCardNetworks: this.defaultAllowedCardNetworks(),
        };
    }

    private static defaultAllowedCardNetworks(): GooglePayCardNetworks[] {
        return [GooglePayCardNetworks.VISA, GooglePayCardNetworks.MASTERCARD];
    }

    private static defaultAllowedAuthMethods(): GooglePayAuthMethods[] {
        return [GooglePayAuthMethods.PAN_ONLY, GooglePayAuthMethods.CRYPTOGRAM_3DS];
    }
}